import { render, staticRenderFns } from "./ConsultationProjectPage.vue?vue&type=template&id=63fa5028&"
import script from "./ConsultationProjectPage.vue?vue&type=script&lang=js&"
export * from "./ConsultationProjectPage.vue?vue&type=script&lang=js&"
import style0 from "./ConsultationProjectPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports